export var PartitionTransform;
(function (PartitionTransform) {
    PartitionTransform["PARTITION_TRANSFORM_IDENTITY"] = "identity";
    PartitionTransform["PARTITION_TRANSFORM_YEAR"] = "year";
    PartitionTransform["PARTITION_TRANSFORM_MONTH"] = "month";
    PartitionTransform["PARTITION_TRANSFORM_DAY"] = "day";
    PartitionTransform["PARTITION_TRANSFORM_HOUR"] = "hour";
    PartitionTransform["PARTITION_TRANSFORM_BUCKET"] = "bucket";
    PartitionTransform["PARTITION_TRANSFORM_TRUNCATE"] = "truncate";
})(PartitionTransform || (PartitionTransform = {}));
